import React from "react";
import { NavBar } from "../../common/NavBar";
import { ClipsPageTabs } from "./ClipsPageTabs";
import { AILinkFilters } from "./AILinkFilters";
import { AILinkTab } from "./AILinkTab";
import { useNavigate, useSearchParams } from "react-router-dom";
import { handleArrowButtonClick } from "./ClipsUtilities/handleArrowButtonClick";
import { SentinelFilters } from "./SentinelFilters";
import { getAllSitesClips } from "./ClipsUtilities/getAllSitesClips";
import { getCamerasBySiteAlerts } from "../Alerts/AlertsUtils/getCamerasBySiteAlerts";
import { SentinelTab } from "./SentinelTab";
import SentinelBackdropLoadingScreen from "../../common/SentinelBackDropLoadingScreen";
import AiLinkBackdropLoadingScreen from "../../common/AiLinkBackDropLoadingScreen";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { useClipsStore } from "./ClipsStore/clipsStore";
import { SMTPTab } from "./SMTPTab";
import { SMTPTabFilters } from "./SMTPTabFilters";
import BackdropLoadingScreen from "../../common/BackdropLoadingScreen";
import { useAppStore } from "../../../appStore";
import { FrontelTab } from "./FrontelTab";
import { FrontelTabFilters } from "./FrontelTabFilters";
import {
  parseClipsSearchParams,
} from "./ClipsUtilities/clipsUrlParams";
import { getAILinkClipsWithQuerry } from "./ClipsUtilities/getAILinkClipsWithQuerry";
import { getSentinelClipsWithQuerry } from "./ClipsUtilities/getSentinelClipsWithQuerry";
import { createEmptyPrecisionRecallData } from "./ClipsUtilities/totalUpPrecisionRecallData";
import { handleRowSelected } from "./ClipsUtilities/handleRowSelected";
import { handleButtonShading } from "./ClipsUtilities/handleButtonShading";
import { handleButtonShadingFrontel } from "./ClipsUtilities/handleButtonShadingFrontel";
import { getUrlClipSelectionOutcome } from "./ClipsUtilities/urlClipSelection";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

export const Clips = ({
  navBarCollapsed,
  setNavBarCollapsed,
}: {
  navBarCollapsed: boolean;
  setNavBarCollapsed: Dispatcher<boolean>;
}) => {
  React.useEffect(() => {
    resetState();
  }, []);

  const [clipsData, setClipsData] = React.useState<any[]>([]);

  const [sentinelData, setSentinelData] = React.useState<any[]>([]);

  const navigate = useNavigate();

  // Remove the local activeTab state - it's now managed by Zustand store
  const {
    activeClipsTab,
    setActiveClipsTab,
    pageLoadingSMTP,
    filtersAppliedSMTP,
    getSMTPData,
    getUserGroupsSMTP,
    getAllSitesClipsSMTP,
    getUserGroupsFrontel,
    resetState,
    setUserFiltersSMTP,
    setUserFiltersFrontel,
    setFiltersAppliedSMTP,
    setFiltersAppliedFrontel,
    getFrontelData,
    setUserDropDownValueFrontel,
    setGroupIDFrontel,
    setFrontelUsername,
    getAllSitesFrontel,
    siteOptionsSMTP,
    setSiteDropDownValueSMTP,
    getCamerasBySiteSMTP,
    siteOptionsFrontel,
    setSiteDropDownValueFrontel,
    getCamerasBySiteFrontel,
    loadingGroupsFrontel,
    setLoadingGroupsFrontel,
  } = useClipsStore();

  const [searchParams, setSearchParams] = useSearchParams();

  const { userPermissions } = useAppStore();

  const [selectedRow, setSelectedRow] = React.useState<any>({});

  const [selectedRowSentinel, setSelectedRowSentinel] = React.useState<any>(
    sentinelData[0]
  );

  const [page, setPage] = React.useState(0);

  const [pageSentinel, setPageSentinel] = React.useState(0);

  const [sentinelFilterApplyToken, setSentinelFilterApplyToken] =
    React.useState(0);

  const [showMoreDialogOpen, setShowMoreDialogOpen] = React.useState(false);

  const [showMoreDialogOpenSentinel, setShowMoreDialogOpenSentinel] =
    React.useState(false);

  const [pageLoading, setPageLoading] = React.useState(false);

  const [pageLoadingSentinel, setPageLoadingSentinel] = React.useState(false);

  const [videoURL, setVideoURL] = React.useState("");

  const [videoURLSentinel, setVideoURLSentinel] = React.useState("");

  const [precisionRecallData, setPrecisionRecallData] = React.useState({
    date: "",
    date_str: "",
    true_positives: 0,
    false_positives: 0,
    false_negatives: 0,
    true_negatives: 0,
    unclassified: 0,
    total_clips: 0,
    precision: null,
    recall: null,
  });

  const [precisionRecallDataSentinel, setPrecisionRecallDataSentinel] =
    React.useState<any>(createEmptyPrecisionRecallData());

  const [videoClipLoading, setVideoClipLoading] = React.useState(true);

  const [videoClipLoadingSentinel, setVideoClipLoadingSentinel] =
    React.useState(true);

  const [clipsIndexOrder, setClipsIndexOrder] = React.useState([]);

  const [clipsIndexOrderSentinel, setClipsIndexOrderSentinel] = React.useState(
    []
  );

  const [verifiedClicked, setVerifiedClicked] = React.useState(true);

  const [unverifiedClicked, setUnverifiedClicked] = React.useState(true);

  const [noDataToDisplay, setNoDataToDisplay] = React.useState(true);

  const [noDataToDisplaySentinel, setNoDataToDisplaySentinel] =
    React.useState(true);

  const [siteOptions, setSiteOptions] = React.useState<any[]>([]);

  const [loadingSites, setLoadingSites] = React.useState(false);

  const startDate = new Date();
  // startDate.setDate(startDate.getDate() - 2);

  const endDate = new Date();

  const [userFilters, setUserFilters] = React.useState({
    user: "",
    start_date: startDate,
    end_date: endDate,
    start_time: null,
    end_time: null,
    ground_truth: null,
    clip_result: null,
    site_ids: [],
    camera_ids: [],
  });

  const [siteDropDownValue, setSiteDropDownValue] = React.useState<
    string | null
  >(null);

  const [cameraDropDownValue, setCameraDropDownValue] = React.useState<
    string | null
  >(null);

  const [cameraOptions, setCameraOptions] = React.useState<any[]>([]);

  const [loadingCameras, setLoadingCameras] = React.useState(false);

  const [fetchingFilteredData, setFetchingFilteredData] = React.useState(false);

  const [fetchingFilteredDataSentinel, setFetchingFilteredDataSentinel] =
    React.useState(false);

  const userInfo = JSON.parse(localStorage.userInfo);

  const showUserDropDown =
    userInfo.permission.ailink_index || userInfo.permission.super_user;

  const showUserDropDownSentinel = userInfo.permission.ailink_index;

  const [userDropDownValue, setUserDropDownValue] = React.useState<
    string | null
  >(null);

  const [groupID, setGroupID] = React.useState(null);

  const aiLinkUsers = JSON.parse(localStorage.aiLinkUsers);

  const sentinelUsers = JSON.parse(localStorage.sentinelUsers);

  const [userDropDownValueSentinel, setUserDropDownValueSentinel] =
    React.useState("");

  const [cameraDropDownValueSentinel, setCameraDropDownValueSentinel] =
    React.useState<string>("");

  const [userFiltersSentinel, setUserFiltersSentinel] = React.useState({
    user: "sentinel",
    group_id: null,
    start_date: startDate,
    end_date: endDate,
    start_time: null,
    end_time: null,
    clip_result: null,
    site_ids: [],
    camera_ids: [],
  });

  const [siteDropDownValueSentinel, setSiteDropDownValueSentinel] =
    React.useState<string | null>(null);

  const [siteOptionsSentinel, setSiteOptionsSentinel] = React.useState<any[]>(
    []
  );

  const [loadingCamerasSentinel, setLoadingCamerasSentinel] =
    React.useState(false);

  const [cameraOptionsSentinel, setCameraOptionsSentinel] = React.useState<
    any[]
  >([]);

  const [loadingSitesSentinel, setLoadingSitesSentinel] = React.useState(false);

  const [aiLinkClipsTotal, setAiLinkClipsTotal] = React.useState(0);

  const [loadingAdditionalData, setLoadingAdditionalData] =
    React.useState(true);

  const [loadingAdditionalDataSentinel, setLoadingAdditionalDataSentinel] =
    React.useState(true);

  const {
    noDataToDisplaySMTP,
    fetchingFilteredDataSMTP,
    noDataToDisplayFrontel,
    filtersAppliedFrontel,
    fetchingFilteredDataFrontel,
    showFrontelTab,
    smtpData,
    setSmtpData,
    selectedRowSMTP,
    setSelectedRowSMTP,
    setVideoClipLoadingSMTP,
    getVideoURLSMTP,
    userFiltersSMTP,
    frontelData,
    setFrontelData,
    selectedRowFrontel,
    setSelectedRowFrontel,
    setVideoClipLoadingFrontel,
    getClipInfoFrontel,
    getVideoURLFrontel,
    userFiltersFrontel,
    setVerifiedClickedFrontel,
    setUnverifiedClickedFrontel,
  } = useClipsStore();

  const forwardClick = () => {
    handleArrowButtonClick(
      clipsData,
      selectedRow,
      clipsIndexOrder,
      "forward",
      setSelectedRow,
      setClipsData,
      setVideoClipLoading,
      setVerifiedClicked,
      setUnverifiedClicked,
      setVideoURL,
      userFilters,
      navigate
    );
  };

  const backClick = () => {
    handleArrowButtonClick(
      clipsData,
      selectedRow,
      clipsIndexOrder,
      "back",
      setSelectedRow,
      setClipsData,
      setVideoClipLoading,
      setVerifiedClicked,
      setUnverifiedClicked,
      setVideoURL,
      userFilters,
      navigate
    );
  };

  const handlers = {
    FORWARD_CLICK: forwardClick,
    BACK_CLICK: backClick,
  };

  const keyMap = {
    FORWARD_CLICK: "right",
    BACK_CLICK: "left",
  };

  const [clickedTab, setClickedTab] = React.useState("one");

  const [filtersApplied, setFiltersApplied] = React.useState(false);

  const [timeFiltersDisabledAILink, setTimeFiltersDisabledAILink] =
    React.useState(false);

  const [timeFiltersDisabledSentinel, setTimeFiltersDisabledSentinel] =
    React.useState(false);

  const [tabsReady, setTabsReady] = React.useState(false);
  const frontelCheckStartedRef = React.useRef(false);
  const handledUrlClipSelectionRef = React.useRef("");
  const [urlClipNotFoundOpen, setUrlClipNotFoundOpen] = React.useState(false);
  const handleUrlClipNotFoundClose = (
    _event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") return;
    setUrlClipNotFoundOpen(false);
  };

  React.useEffect(() => {
    frontelCheckStartedRef.current = true;
    setLoadingGroupsFrontel(true);
    getUserGroupsFrontel(navigate);
  }, [navigate]);

  React.useEffect(() => {
    if (frontelCheckStartedRef.current && !loadingGroupsFrontel) {
      setTabsReady(true);
    }
  }, [loadingGroupsFrontel]);

  React.useEffect(() => {
    const userInfo = JSON.parse(localStorage.userInfo);

    if (
      showUserDropDown &&
      userInfo.permission.ailink &&
      !userInfo.permission.sentinel
    ) {
      setActiveClipsTab("ailink");
      setClickedTab("one");
      setPageLoading(false);
    }

    if (
      showUserDropDown &&
      userInfo.permission.ailink &&
      userInfo.permission.sentinel
    ) {
      setActiveClipsTab("ailink");
      setClickedTab("one");
      setPageLoading(false);
      setPageLoadingSentinel(false);
    }

    if (
      showUserDropDown &&
      !userInfo.permission.ailink &&
      userInfo.permission.sentinel
    ) {
      setActiveClipsTab("sentinel");
      setClickedTab("one");
      setPageLoadingSentinel(false);
    }

    const aiLinkUsers = JSON.parse(localStorage.aiLinkUsers);

    const sentinelUsers = JSON.parse(localStorage.sentinelUsers);

    if (!showUserDropDown && userInfo.permission.ailink) {
      const userInfo = JSON.parse(localStorage.userInfo);
      // setFetchingFilteredData(true);

      if (userInfo.permission.ailink) {
        setActiveClipsTab("ailink");
        setClickedTab("one");
        // Plain ailink users never see the user dropdown that would set
        // userFilters.user / groupID, so self-populate them from the user's
        // own immix credential. Without this, userFilters.user stays "" and
        // the report prefetch in AILinkFilters bails on `!userFilters?.user`,
        // leaving the Download Report button permanently disabled (BT-1136).
        if (aiLinkUsers[0]) {
          setUserFilters((previousState: any) => {
            return { ...previousState, user: aiLinkUsers[0].username };
          });
          if (aiLinkUsers[0].group) {
            setUserDropDownValue(aiLinkUsers[0].group.name);
            setGroupID(aiLinkUsers[0].group.id);
          }
        }
        getAllSitesClips(
          setSiteOptions,
          setLoadingSites,
          userInfo.group.id,
          navigate
        );
      }
    }

    if (!showUserDropDown && userInfo.permission.sentinel) {
      // setFetchingFilteredDataSentinel(true);
      setActiveClipsTab("sentinel");
      setClickedTab("two");
      if (sentinelUsers[0]) {
        setUserFiltersSentinel((previousState: any) => {
          return {
            ...previousState,
            user: sentinelUsers[0].username,
            group_id: sentinelUsers[0].group?.id ?? null,
          };
        });
        getAllSitesClips(
          setSiteOptionsSentinel,
          setLoadingSitesSentinel,
          sentinelUsers[0].group.id,
          navigate
        );
      }
    }
    if (
      !showUserDropDown &&
      userInfo.permission.smtp &&
      !userInfo.permission.ailink &&
      !userInfo.permission.sentinel
    ) {
      setActiveClipsTab("smtp");
      setClickedTab("three");
      setPageLoading(false);
    }

    if (
      !showUserDropDown &&
      userInfo.permission.sentinel &&
      userInfo.permission.smtp &&
      !userInfo.permission.ailink
    ) {
      setActiveClipsTab("sentinel");
      setClickedTab("two");
      if (sentinelUsers[0]) {
        setUserFiltersSentinel((previousState: any) => {
          return {
            ...previousState,
            user: sentinelUsers[0].username,
            group_id: sentinelUsers[0].group?.id ?? null,
          };
        });
        getAllSitesClips(
          setSiteOptionsSentinel,
          setLoadingSitesSentinel,
          sentinelUsers[0].group.id,
          navigate
        );
      }
    }
    if (
      !userInfo.permission.ailink &&
      !userInfo.permission.sentinel &&
      !userInfo.permission.smtp &&
      showFrontelTab
    ) {
      setActiveClipsTab("frontel");
      setClickedTab("four");
      setPageLoading(false);
    }
  }, []);

  React.useEffect(() => {
    const userInfo = JSON.parse(localStorage.userInfo);
    if (
      !userInfo.permission.ailink &&
      !userInfo.permission.sentinel &&
      !userInfo.permission.smtp &&
      showFrontelTab
    ) {
      setActiveClipsTab("frontel");
      setClickedTab("four");
      setPageLoading(false);
    }
  }, [showFrontelTab]);

  const hasAppliedUrlParamsRef = React.useRef(false);

  React.useEffect(() => {
    if (Array.from(searchParams).length === 0) return;

    const userInfo = JSON.parse(localStorage.userInfo);
    const parsed = parseClipsSearchParams(searchParams);

    const tabToClickedTab: Record<string, string> = {
      ailink: "one",
      sentinel: "two",
      smtp: "three",
      frontel: "four",
    };

    const isTabVisible = (tab: string) => {
      if (tab === "ailink") return !!userInfo.permission.ailink;
      if (tab === "sentinel") return !!userInfo.permission.sentinel;
      if (tab === "smtp") return !!userInfo.permission.smtp;
      if (tab === "frontel") return !!showFrontelTab;
      return false;
    };

    const urlTabVisible = parsed.tab ? isTabVisible(parsed.tab) : false;
    if (parsed.tab && urlTabVisible) {
      setActiveClipsTab(parsed.tab);
      setClickedTab(tabToClickedTab[parsed.tab] || "one");
    }

    const effectiveTab =
      parsed.tab && isTabVisible(parsed.tab) ? parsed.tab : activeClipsTab;
    const validTabs = ["ailink", "sentinel", "smtp", "frontel"];
    if (!effectiveTab || !validTabs.includes(effectiveTab)) return;

    if (parsed.hasAnyFilterParam && effectiveTab === parsed.tab) {
      if (hasAppliedUrlParamsRef.current) return;
      hasAppliedUrlParamsRef.current = true;
      const baseStart = userFilters.start_date;
      const baseEnd = userFilters.end_date;

      if (effectiveTab === "ailink") {
        setUserFilters((prev: any) => ({
          ...prev,
          user: parsed.user ?? prev.user,
          site_ids: parsed.siteIds.length ? parsed.siteIds : prev.site_ids,
          camera_ids: parsed.cameraIds.length
            ? parsed.cameraIds
            : prev.camera_ids,
          start_date: parsed.start_date ?? baseStart,
          end_date: parsed.end_date ?? baseEnd,
          start_time: parsed.start_time ?? prev.start_time,
          end_time: parsed.end_time ?? prev.end_time,
          ground_truth: parsed.ground_truth ?? prev.ground_truth,
          clip_result: parsed.clip_result ?? prev.clip_result,
        }));
        const ailinkUsersFromStorage = (() => {
          try {
            return JSON.parse(localStorage.aiLinkUsers || "[]");
          } catch {
            return [];
          }
        })();
        const ailinkMatch = ailinkUsersFromStorage.find(
          (o: any) =>
            o?.username === (parsed.user ?? parsed.group) ||
            o?.group?.name === (parsed.user ?? parsed.group)
        );
        if (ailinkMatch?.group?.name) {
          setUserDropDownValue(ailinkMatch.group.name);
          if (ailinkMatch.group.id != null) {
            setGroupID(ailinkMatch.group.id);
            getAllSitesClips(
              setSiteOptions,
              setLoadingSites,
              ailinkMatch.group.id,
              navigate
            );
          }
        }
      } else if (effectiveTab === "sentinel") {
        setUserFiltersSentinel((prev: any) => ({
          ...prev,
          user: parsed.user ?? prev.user,
          site_ids: parsed.siteIds.length ? parsed.siteIds : prev.site_ids,
          camera_ids: parsed.cameraIds.length
            ? parsed.cameraIds
            : prev.camera_ids,
          start_date: parsed.start_date ?? baseStart,
          end_date: parsed.end_date ?? baseEnd,
          start_time: parsed.start_time ?? prev.start_time,
          end_time: parsed.end_time ?? prev.end_time,
          clip_result: parsed.clip_result ?? prev.clip_result,
        }));
        const sentinelUsersFromStorage = (() => {
          try {
            return JSON.parse(localStorage.sentinelUsers || "[]");
          } catch {
            return [];
          }
        })();
        const sentinelMatch = sentinelUsersFromStorage.find(
          (o: any) =>
            o?.username === (parsed.user ?? parsed.group) ||
            o?.group?.name === (parsed.user ?? parsed.group)
        );
        if (sentinelMatch?.group?.name) {
          setUserDropDownValueSentinel(sentinelMatch.group.name);
          if (sentinelMatch.group.id != null) {
            setUserFiltersSentinel((prev: any) => ({
              ...prev,
              group_id: sentinelMatch.group.id,
            }));
            getAllSitesClips(
              setSiteOptionsSentinel,
              setLoadingSitesSentinel,
              sentinelMatch.group.id,
              navigate
            );
          }
        }
      } else if (effectiveTab === "smtp") {
        setUserFiltersSMTP((prev: any) => ({
          ...prev,
          site_ids: parsed.siteIds.length ? parsed.siteIds : prev.site_ids,
          camera_ids: parsed.cameraIds.length
            ? parsed.cameraIds
            : prev.camera_ids,
          start_date: parsed.start_date ?? prev.start_date,
          end_date: parsed.end_date ?? prev.end_date,
          start_time: parsed.start_time ?? prev.start_time,
          end_time: parsed.end_time ?? prev.end_time,
        }));
        const smtpUserParam = parsed.user ?? parsed.group;
        if (smtpUserParam) {
          try {
            const parentAccounts = JSON.parse(
              localStorage.parentAccounts || "[]"
            );
            const idNum = parseInt(String(smtpUserParam).trim(), 10);
            const matchById = !Number.isNaN(idNum);
            const smtpMatch = (parentAccounts || []).find((o: any) =>
              matchById
                ? o?.id === idNum || o?.id == smtpUserParam
                : o?.name === smtpUserParam
            );
            if (smtpMatch?.id != null) {
              const store = useClipsStore.getState();
              store.setUserDropDownValueSMTP(smtpMatch.name);
              store.setGroupIDSMTP(smtpMatch.id);
              setUserFiltersSMTP((prev: any) => ({
                ...prev,
                user: smtpMatch.id,
                group_id: smtpMatch.id,
              }));
              getAllSitesClipsSMTP(smtpMatch.id, navigate);
              store.getDownloadURLSMTP(navigate);
            }
          } catch {
            // ignore
          }
        }
      } else if (effectiveTab === "frontel") {
        const groupOptionsFrontel =
          useClipsStore.getState().groupOptionsFrontel || [];
        const userParam = parsed.user ?? parsed.group;
        let resolvedUsername = userParam ?? "";
        let resolvedGroupName: string | null = null;
        let resolvedGroupId: number | null = null;

        if (userParam && groupOptionsFrontel.length > 0) {
          const match = groupOptionsFrontel.find(
            (o: any) =>
              o?.username === userParam || o?.group?.name === userParam
          );
          if (match?.group) {
            resolvedUsername = match.username ?? userParam;
            resolvedGroupName = match.group.name;
            resolvedGroupId = match.group.id ?? null;
          }
        }

        setUserFiltersFrontel((prev: any) => ({
          ...prev,
          user: resolvedUsername || prev.user,
          site_ids: parsed.siteIds.length ? parsed.siteIds : prev.site_ids,
          camera_ids: parsed.cameraIds.length
            ? parsed.cameraIds
            : prev.camera_ids,
          start_date: parsed.start_date ?? prev.start_date,
          end_date: parsed.end_date ?? prev.end_date,
          start_time: parsed.start_time ?? prev.start_time,
          end_time: parsed.end_time ?? prev.end_time,
        }));

        if (resolvedUsername) {
          setFrontelUsername(resolvedUsername);
        }
        if (resolvedGroupName !== null) {
          setUserDropDownValueFrontel(resolvedGroupName);
        }
        if (resolvedGroupId !== null) {
          setGroupIDFrontel(resolvedGroupId);
          getAllSitesFrontel(resolvedGroupId, navigate);
        }
      }

      if (effectiveTab === "ailink") {
        const ailinkFilters = {
          ...userFilters,
          user: parsed.user ?? userFilters.user,
          site_ids: parsed.siteIds.length
            ? parsed.siteIds
            : userFilters.site_ids,
          camera_ids: parsed.cameraIds.length
            ? parsed.cameraIds
            : userFilters.camera_ids,
          start_date: parsed.start_date ?? userFilters.start_date,
          end_date: parsed.end_date ?? userFilters.end_date,
          start_time: parsed.start_time ?? userFilters.start_time,
          end_time: parsed.end_time ?? userFilters.end_time,
          ground_truth: parsed.ground_truth ?? userFilters.ground_truth,
          clip_result: parsed.clip_result ?? userFilters.clip_result,
        };
        setFiltersApplied(true);
        setFetchingFilteredData(true);
        setClipsData([]);
        setPage(0);
        setNoDataToDisplay(true);
        setSelectedRow({});
        getAILinkClipsWithQuerry(
          setClipsData,
          setPageLoading,
          setSelectedRow,
          setPrecisionRecallData,
          setVideoURL,
          setVideoClipLoading,
          setClipsIndexOrder,
          setVerifiedClicked,
          setUnverifiedClicked,
          selectedRow,
          setNoDataToDisplay,
          setSiteOptions,
          setLoadingSites,
          ailinkFilters,
          setFetchingFilteredData,
          setPage,
          false,
          "",
          "",
          setLoadingAdditionalData,
          navigate
        );
      } else if (effectiveTab === "sentinel") {
        const sentinelFilters = {
          ...userFiltersSentinel,
          user: parsed.user ?? userFiltersSentinel.user,
          site_ids: parsed.siteIds.length
            ? parsed.siteIds
            : userFiltersSentinel.site_ids,
          camera_ids: parsed.cameraIds.length
            ? parsed.cameraIds
            : userFiltersSentinel.camera_ids,
          start_date: parsed.start_date ?? userFiltersSentinel.start_date,
          end_date: parsed.end_date ?? userFiltersSentinel.end_date,
          start_time: parsed.start_time ?? userFiltersSentinel.start_time,
          end_time: parsed.end_time ?? userFiltersSentinel.end_time,
          clip_result: parsed.clip_result ?? userFiltersSentinel.clip_result,
        };
        setFiltersApplied(true);
        setFetchingFilteredDataSentinel(true);
        setSentinelData([]);
        setPageSentinel(0);
        setNoDataToDisplaySentinel(true);
        setSelectedRowSentinel({});
        getSentinelClipsWithQuerry(
          setSentinelData,
          setPageLoadingSentinel,
          setSelectedRowSentinel,
          setPrecisionRecallDataSentinel,
          setVideoURLSentinel,
          setVideoClipLoadingSentinel,
          setClipsIndexOrderSentinel,
          selectedRowSentinel,
          setNoDataToDisplaySentinel,
          setSiteOptionsSentinel,
          setLoadingSitesSentinel,
          sentinelFilters,
          setFetchingFilteredDataSentinel,
          setPageSentinel,
          "",
          "",
          false,
          setLoadingAdditionalDataSentinel,
          navigate
        );
      } else if (effectiveTab === "smtp" && parsed.siteIds.length > 0) {
        setFiltersAppliedSMTP(true);
        getSMTPData(navigate);
      } else if (effectiveTab === "frontel") {
        setFiltersAppliedFrontel(true);
        getFrontelData(navigate);
      }
    }
  }, [showFrontelTab]);

  // When Sentinel URL params change (e.g. initial load or after Apply), sync dropdown and load sites from URL.
  // Deps only [searchParams] so we do NOT run on every re-render (sentinelUsers is read inside; including it would overwrite user's dropdown choice).
  React.useEffect(() => {
    if (
      !hasAppliedUrlParamsRef.current ||
      !searchParams.get("tab") ||
      searchParams.get("tab") !== "sentinel"
    )
      return;
    const userParam = searchParams.get("user") || searchParams.get("group");
    if (!userParam) return;
    let users: any[] = [];
    try {
      users = JSON.parse(localStorage.sentinelUsers || "[]");
    } catch {
      return;
    }
    if (!users?.length) return;
    const match = users.find(
      (o: any) => o?.username === userParam || o?.group?.name === userParam
    );
    if (match?.group?.name) {
      setUserDropDownValueSentinel(match.group.name);
      if (match.group.id != null) {
        setUserFiltersSentinel((prev: any) => ({
          ...prev,
          group_id: match.group.id,
        }));
        getAllSitesClips(
          setSiteOptionsSentinel,
          setLoadingSitesSentinel,
          match.group.id,
          navigate
        );
      }
    }
  }, [searchParams]);

  // When Sentinel URL params included site= and sites have loaded, set site dropdown and load cameras.
  // Only sync site from URL when URL user/group matches the currently selected dropdown (userDropDownValueSentinel = group name).
  React.useEffect(() => {
    if (
      !hasAppliedUrlParamsRef.current ||
      searchParams.get("tab") !== "sentinel"
    )
      return;
    const parsed = parseClipsSearchParams(searchParams);
    if (!parsed.siteIds?.length || !siteOptionsSentinel?.length) return;
    let urlMatchesSelection = true;
    try {
      const users = JSON.parse(localStorage.sentinelUsers || "[]");
      const sel = users?.find(
        (o: any) => o?.group?.name === userDropDownValueSentinel
      );
      if (sel && (parsed.user || parsed.group)) {
        urlMatchesSelection =
          parsed.user === sel.username ||
          parsed.user === sel.group?.name ||
          String(parsed.group) === String(sel.group?.id);
      }
    } catch {
      // ignore
    }
    if (!urlMatchesSelection) return;
    const siteId = parsed.siteIds[0];
    const site = siteOptionsSentinel.find((s: any) => s.id === siteId);
    if (!site || siteDropDownValueSentinel === site.name) return;
    setSiteDropDownValueSentinel(site.name);
    getCamerasBySiteAlerts(
      [String(siteId)],
      navigate,
      setCameraOptionsSentinel,
      setLoadingCamerasSentinel
    );
  }, [searchParams, siteOptionsSentinel, siteDropDownValueSentinel, userDropDownValueSentinel]);

  // When AILink URL params change (e.g. initial load or after Apply), sync dropdown and load sites from URL.
  // Deps only [searchParams] so we do NOT run on every re-render (aiLinkUsers is read inside; including it would run every render and overwrite user's dropdown choice).
  React.useEffect(() => {
    if (!hasAppliedUrlParamsRef.current || searchParams.get("tab") !== "ailink")
      return;
    const userParam = searchParams.get("user") || searchParams.get("group");
    if (!userParam) return;
    let users: any[] = [];
    try {
      users = JSON.parse(localStorage.aiLinkUsers || "[]");
    } catch {
      return;
    }
    if (!users?.length) return;
    const match = users.find(
      (o: any) => o?.username === userParam || o?.group?.name === userParam
    );
    if (match?.group?.name) {
      setUserDropDownValue(match.group.name);
      if (match.group.id != null) {
        setGroupID(match.group.id);
        getAllSitesClips(
          setSiteOptions,
          setLoadingSites,
          match.group.id,
          navigate
        );
      }
    }
  }, [searchParams]);

  // When AILink URL params included site= and sites have loaded, set site dropdown and load cameras.
  // Only sync site from URL when URL group matches the currently selected user's group (by userDropDownValue), not groupID state which can be stale.
  React.useEffect(() => {
    if (!hasAppliedUrlParamsRef.current || searchParams.get("tab") !== "ailink")
      return;
    const parsed = parseClipsSearchParams(searchParams);
    if (!parsed.siteIds?.length || !siteOptions?.length) return;
    const urlGroupId = parsed.group ? parseInt(parsed.group, 10) : null;
    let selectedGroupId: number | null = null;
    try {
      const users = JSON.parse(localStorage.aiLinkUsers || "[]");
      const sel = users?.find((o: any) => o?.group?.name === userDropDownValue);
      selectedGroupId = sel?.group?.id ?? null;
    } catch {
      // ignore
    }
    if (urlGroupId != null && selectedGroupId != null && urlGroupId !== selectedGroupId) return;
    const siteId = parsed.siteIds[0];
    const site = siteOptions.find((s: any) => s.id === siteId);
    if (!site || siteDropDownValue === site.name) return;
    setSiteDropDownValue(site.name);
    getCamerasBySiteAlerts(
      [String(siteId)],
      navigate,
      setCameraOptions,
      setLoadingCameras
    );
  }, [searchParams, siteOptions, siteDropDownValue, userDropDownValue]);

  // When SMTP URL params included site= and sites have loaded, set site dropdown and load cameras
  React.useEffect(() => {
    if (!hasAppliedUrlParamsRef.current || searchParams.get("tab") !== "smtp")
      return;
    const parsed = parseClipsSearchParams(searchParams);
    if (!parsed.siteIds?.length || !siteOptionsSMTP?.length) return;
    const siteId = parsed.siteIds[0];
    const site = siteOptionsSMTP.find(
      (s: any) => s.id === siteId || s.id == siteId
    );
    if (!site) return;
    const store = useClipsStore.getState();
    if (store.siteDropDownValueSMTP === site.name) return;
    setSiteDropDownValueSMTP(site.name);
    getCamerasBySiteSMTP([String(siteId)], navigate);
  }, [searchParams, siteOptionsSMTP]);

  // When Frontel URL params included site= and sites have loaded, set site dropdown and load cameras
  React.useEffect(() => {
    if (
      !hasAppliedUrlParamsRef.current ||
      searchParams.get("tab") !== "frontel"
    )
      return;
    const parsed = parseClipsSearchParams(searchParams);
    if (!parsed.siteIds?.length || !siteOptionsFrontel?.length) return;
    const siteId = parsed.siteIds[0];
    const site = siteOptionsFrontel.find((s: any) => s.id === siteId);
    if (!site) return;
    const store = useClipsStore.getState();
    if (store.siteDropDownValueFrontel === site.name) return;
    setSiteDropDownValueFrontel(site.name);
    getCamerasBySiteFrontel([String(siteId)], navigate);
  }, [searchParams, siteOptionsFrontel]);

  React.useEffect(() => {
    const parsed = parseClipsSearchParams(searchParams);
    const tab = parsed.tab;
    if (!tab) return;

    const targetId = tab === "smtp" ? parsed.clip_id : parsed.file_id;
    if (!targetId) return;

    const selectionKey = `${tab}:${targetId}`;
    if (handledUrlClipSelectionRef.current === selectionKey) return;
    const uuidV4LikeRegex =
      /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    if (tab === "ailink") {
      const outcome = getUrlClipSelectionOutcome({
        tab: "ailink",
        targetId,
        clipsData,
        sentinelData,
        smtpData,
        frontelData,
        fetchingFilteredData,
        fetchingFilteredDataSentinel,
        fetchingFilteredDataSMTP,
        fetchingFilteredDataFrontel,
        filtersApplied,
        filtersAppliedSMTP,
        filtersAppliedFrontel,
      });
      if (outcome.status === "skip") return;
      if (outcome.status === "not_found") {
        handledUrlClipSelectionRef.current = selectionKey;
        setUrlClipNotFoundOpen(true);
        return;
      }
      const row = outcome.row;
      handledUrlClipSelectionRef.current = selectionKey;
      setVideoClipLoading(true);
      handleButtonShading(row, setVerifiedClicked, setUnverifiedClicked);
      handleRowSelected(
        row,
        setSelectedRow,
        setVideoURL,
        setVideoClipLoading,
        clipsData,
        setClipsData,
        selectedRow,
        userFilters,
        "ailink",
        userFilters.user,
        navigate
      );
      return;
    }

    if (tab === "sentinel") {
      if (!uuidV4LikeRegex.test(targetId)) {
        handledUrlClipSelectionRef.current = selectionKey;
        setUrlClipNotFoundOpen(true);
        return;
      }
      if (loadingAdditionalDataSentinel) {
        const rowWhileLoading =
          sentinelData.find((item: any) => item.file_id === targetId) ?? null;
        if (rowWhileLoading) {
          handledUrlClipSelectionRef.current = selectionKey;
          setVideoClipLoadingSentinel(true);
          handleRowSelected(
            rowWhileLoading,
            setSelectedRowSentinel,
            setVideoURLSentinel,
            setVideoClipLoadingSentinel,
            sentinelData,
            setSentinelData,
            selectedRowSentinel,
            userFiltersSentinel,
            "sentinel",
            userFiltersSentinel.user,
            navigate
          );
        }
        return;
      }
      const outcome = getUrlClipSelectionOutcome({
        tab: "sentinel",
        targetId,
        clipsData,
        sentinelData,
        smtpData,
        frontelData,
        fetchingFilteredData,
        fetchingFilteredDataSentinel,
        fetchingFilteredDataSMTP,
        fetchingFilteredDataFrontel,
        filtersApplied,
        filtersAppliedSMTP,
        filtersAppliedFrontel,
      });
      if (outcome.status === "skip") return;
      if (outcome.status === "not_found") {
        handledUrlClipSelectionRef.current = selectionKey;
        setUrlClipNotFoundOpen(true);
        return;
      }
      const row = outcome.row;
      handledUrlClipSelectionRef.current = selectionKey;
      setVideoClipLoadingSentinel(true);
      handleRowSelected(
        row,
        setSelectedRowSentinel,
        setVideoURLSentinel,
        setVideoClipLoadingSentinel,
        sentinelData,
        setSentinelData,
        selectedRowSentinel,
        userFiltersSentinel,
        "sentinel",
        userFiltersSentinel.user,
        navigate
      );
      return;
    }

    if (tab === "smtp") {
      const outcome = getUrlClipSelectionOutcome({
        tab: "smtp",
        targetId,
        clipsData,
        sentinelData,
        smtpData,
        frontelData,
        fetchingFilteredData,
        fetchingFilteredDataSentinel,
        fetchingFilteredDataSMTP,
        fetchingFilteredDataFrontel,
        filtersApplied,
        filtersAppliedSMTP,
        filtersAppliedFrontel,
      });
      if (outcome.status === "skip") return;
      if (outcome.status === "not_found") {
        handledUrlClipSelectionRef.current = selectionKey;
        setUrlClipNotFoundOpen(true);
        return;
      }
      const row = outcome.row;
      handledUrlClipSelectionRef.current = selectionKey;
      setSmtpData(
        smtpData.map((item: any) => ({
          ...item,
          selected: item.clip_id === row.clip_id,
        }))
      );
      setVideoClipLoadingSMTP(true);
      setSelectedRowSMTP(row);
      getVideoURLSMTP(row.clip_id, navigate);
      localStorage.setItem("clipsSelectedRow", JSON.stringify(row));
      return;
    }

    if (tab === "frontel") {
      const outcome = getUrlClipSelectionOutcome({
        tab: "frontel",
        targetId,
        clipsData,
        sentinelData,
        smtpData,
        frontelData,
        fetchingFilteredData,
        fetchingFilteredDataSentinel,
        fetchingFilteredDataSMTP,
        fetchingFilteredDataFrontel,
        filtersApplied,
        filtersAppliedSMTP,
        filtersAppliedFrontel,
      });
      if (outcome.status === "skip") return;
      if (outcome.status === "not_found") {
        handledUrlClipSelectionRef.current = selectionKey;
        setUrlClipNotFoundOpen(true);
        return;
      }
      const row = outcome.row;
      handledUrlClipSelectionRef.current = selectionKey;
      setFrontelData(
        frontelData.map((item: any) => ({
          ...item,
          selected: item.file_id === row.file_id,
        }))
      );
      setVideoClipLoadingFrontel(true);
      setSelectedRowFrontel(row);
      handleButtonShadingFrontel(
        row,
        setVerifiedClickedFrontel,
        setUnverifiedClickedFrontel
      );
      getClipInfoFrontel(row.file_id, navigate);
      getVideoURLFrontel(row.file_id, navigate);
      localStorage.setItem("clipsSelectedRow", JSON.stringify(row));
    }
  }, [
    searchParams,
    clipsData,
    sentinelData,
    smtpData,
    frontelData,
    fetchingFilteredData,
    fetchingFilteredDataSentinel,
    fetchingFilteredDataSMTP,
    fetchingFilteredDataFrontel,
    filtersApplied,
    filtersAppliedSMTP,
    filtersAppliedFrontel,
    selectedRow,
    selectedRowSentinel,
    userFilters,
    userFiltersSentinel,
    navigate,
    setVideoClipLoading,
    setVideoClipLoadingSentinel,
    setVideoClipLoadingSMTP,
    setVideoClipLoadingFrontel,
    setSelectedRow,
    setSelectedRowSentinel,
    setSelectedRowSMTP,
    setSelectedRowFrontel,
    setClipsData,
    setSentinelData,
    setSmtpData,
    setFrontelData,
    setVideoURL,
    setVideoURLSentinel,
    setVerifiedClicked,
    setUnverifiedClicked,
    setVerifiedClickedFrontel,
    setUnverifiedClickedFrontel,
    getVideoURLSMTP,
    getClipInfoFrontel,
    getVideoURLFrontel,
  ]);

  React.useEffect(() => {
    setAiLinkClipsTotal(clipsData.length);
  }, [clipsData]);

  React.useEffect(() => {
    // if (userPermissions.super_user) {
    //   getUserGroupsSMTP(navigate);
    // }
    // else {
    const userInfo = JSON.parse(localStorage.userInfo);
    getAllSitesClipsSMTP(userInfo.group.id, navigate);
    // }
  }, []);

  const ref = React.useRef<HTMLDivElement>(null);

  const setScrollTop = (event: any) => {
    localStorage.setItem("clipsScrollTop", event.target.scrollTop);
  };

  React.useEffect(() => {
    if (ref) {
      if (ref.current !== null) {
        ref.current.scrollTop = localStorage.clipsScrollTop;
      }
    }
  }, [clipsData]);

  const scrollToTop = () => {
    if (ref) {
      if (ref.current !== null) {
        ref.current.scrollTop = 62;
      }
    }
  };

  React.useEffect(() => {
    const userInfo = JSON.parse(localStorage.userInfo);
    if (!userInfo.permission.ailink || !userInfo.permission.sentinel) {
      scrollToTop();
    }
  }, []);

  // React.useEffect(() => {
  //     getSMTPData(groupID, navigate);

  // }, []);

  const parentAccounts = JSON.parse(localStorage.parentAccounts);

  let userPerissionNumber = 0;

  if (userInfo.permission.ailink) {
    userPerissionNumber++;
  }
  if (userInfo.permission.sentinel) {
    userPerissionNumber++;
  }
  if (userInfo.permission.smtp) {
    userPerissionNumber++;
  }
  if (showFrontelTab) {
    userPerissionNumber++;
  }

  const hasUrlParams = Array.from(searchParams).length > 0;
  const parsedUrlTab = hasUrlParams
    ? parseClipsSearchParams(searchParams).tab
    : null;
  const urlWantsFrontel = hasUrlParams && parsedUrlTab === "frontel";
  const showTabs =
    tabsReady && (!hasUrlParams || !urlWantsFrontel || showFrontelTab);
  const clipsFilterBandHeight = userPerissionNumber > 1 ? 152 : 92;

  return (
    // <HotKeys handlers={handlers} keyMap={keyMap}>
    <div>
      {/* <BackdropLoadingScreen openState={pageLoadingSentinel} /> */}
      <AiLinkBackdropLoadingScreen
        openState={fetchingFilteredData}
        aiLinkClipsTotal={aiLinkClipsTotal}
      />
      {/* <BackdropLoadingScreen openState={fetchingFilteredDataSentinel} /> */}
      <SentinelBackdropLoadingScreen openState={fetchingFilteredDataSentinel} />
      {fetchingFilteredDataSMTP && (
        <BackdropLoadingScreen openState={fetchingFilteredDataSMTP} />
      )}
      {fetchingFilteredDataFrontel && (
        <BackdropLoadingScreen openState={fetchingFilteredDataFrontel} />
      )}
      <div
        className="absolute w-full h-full overflow-scroll"
        style={{
          background: `linear-gradient(to bottom, #FFFFFF 0px, #FFFFFF ${clipsFilterBandHeight}px, #E5E5E5 ${clipsFilterBandHeight}px, #E5E5E5 100%)`,
          backgroundAttachment: "local",
        }}
        onScroll={setScrollTop}
        ref={ref}
      >
        {showTabs && (
        <>
        <div
          className={
            !navBarCollapsed
              ? "absolute top-0 left-[170px] right-[1px] z-10"
              : "absolute top-0 left-[95px] right-[1px] z-10"
          }
        >
          <ClipsPageTabs
            clickedTab={clickedTab}
            setClickedTab={setClickedTab}
          />
        </div>
        {!pageLoadingSentinel &&
          activeClipsTab === "sentinel" &&
          !(
            userInfo.permission.smtp &&
            !userInfo.permission.ailink &&
            !userInfo.permission.sentinel
          ) && (
            <div>
              <div
                className={
                  userPerissionNumber > 1
                    ? `absolute h-[152px] left-[0px] right-0`
                    : `absolute h-[92px] left-[0px] right-0`
                }
              >
                <div>
                  <div
                    className={
                      !navBarCollapsed
                        ? "font-mulish absolute left-[160px] top-[15px]"
                        : "font-mulish absolute left-[85px] top-[15px]"
                    }
                  >
                    <SentinelFilters
                      showUserDropDownSentinel={showUserDropDownSentinel}
                      userDropDownValueSentinel={userDropDownValueSentinel}
                      userOptions={sentinelUsers}
                      setUserDropDownValueSentinel={
                        setUserDropDownValueSentinel
                      }
                      setCameraDropDownValueSentinel={
                        setCameraDropDownValueSentinel
                      }
                      setUserFiltersSentinel={setUserFiltersSentinel}
                      setSiteDropDownValueSentinel={
                        setSiteDropDownValueSentinel
                      }
                      setSiteOptionsSentinel={setSiteOptionsSentinel}
                      setCameraOptionsSentinel={setCameraOptionsSentinel}
                      setLoadingSitesSentinel={setLoadingSitesSentinel}
                      siteOptionsSentinel={siteOptionsSentinel}
                      loadingSitesSentinel={loadingSitesSentinel}
                      siteDropDownValueSentinel={siteDropDownValueSentinel}
                      setLoadingCamerasSentinel={setLoadingCamerasSentinel}
                      cameraOptionsSentinel={cameraOptionsSentinel}
                      cameraDropDownValueSentinel={cameraDropDownValueSentinel}
                      loadingCamerasSentinel={loadingCamerasSentinel}
                      userFiltersSentinel={userFiltersSentinel}
                      setSentinelData={setSentinelData}
                      setPageLoadingSentinel={setPageLoadingSentinel}
                      setSelectedRowSentinel={setSelectedRowSentinel}
                      setPrecisionRecallDataSentinel={
                        setPrecisionRecallDataSentinel
                      }
                      setVideoURLSentinel={setVideoURLSentinel}
                      setVideoClipLoadingSentinel={setVideoClipLoadingSentinel}
                      setClipsIndexOrderSentinel={setClipsIndexOrderSentinel}
                      selectedRowSentinel={selectedRowSentinel}
                      setNoDataToDisplaySentinel={setNoDataToDisplaySentinel}
                      setFetchingFilteredDataSentinel={
                        setFetchingFilteredDataSentinel
                      }
                      setPageSentinel={setPageSentinel}
                      onSentinelFiltersApply={() => {
                        setSentinelFilterApplyToken((previous) => previous + 1);
                        setPageSentinel(0);
                      }}
                      setLoadingAdditionalData={
                        setLoadingAdditionalDataSentinel
                      }
                      navBarCollapsed={navBarCollapsed}
                      setFiltersApplied={setFiltersApplied}
                      timeFiltersDisabledSentinel={timeFiltersDisabledSentinel}
                      setTimeFiltersDisabledSentinel={
                        setTimeFiltersDisabledSentinel
                      }
                      userInfo={userInfo}
                      navigate={navigate}
                      setSearchParams={setSearchParams}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div>
                  {!noDataToDisplaySentinel && filtersApplied && (
                    <div>
                      <SentinelTab
                        showMoreDialogOpenSentinel={showMoreDialogOpenSentinel}
                        setShowMoreDialogOpenSentinel={
                          setShowMoreDialogOpenSentinel
                        }
                        selectedRowSentinel={selectedRowSentinel}
                        videoURLSentinel={videoURLSentinel}
                        sentinelData={sentinelData}
                        pageSentinel={pageSentinel}
                        setPageSentinel={setPageSentinel}
                        sentinelFilterApplyToken={sentinelFilterApplyToken}
                        precisionRecallDataSentinel={
                          precisionRecallDataSentinel
                        }
                        videoClipLoadingSentinel={videoClipLoadingSentinel}
                        setVideoURLSentinel={setVideoURLSentinel}
                        setVideoClipLoadingSentinel={
                          setVideoClipLoadingSentinel
                        }
                        setSelectedRowSentinel={setSelectedRowSentinel}
                        setSentinelData={setSentinelData}
                        scrollToTop={scrollToTop}
                        setPageLoadingSentinel={setPageLoadingSentinel}
                        clipsIndexOrderSentinel={clipsIndexOrderSentinel}
                        setClipsIndexOrderSentinel={setClipsIndexOrderSentinel}
                        fetchingFilteredDataSentinel={
                          fetchingFilteredDataSentinel
                        }
                        userFiltersSentinel={userFiltersSentinel}
                        loadingAdditionalData={loadingAdditionalDataSentinel}
                        navBarCollapsed={navBarCollapsed}
                        userInfo={userInfo}
                        navigate={navigate}
                      />
                    </div>
                  )}
                  {noDataToDisplaySentinel &&
                    filtersApplied &&
                    !fetchingFilteredDataSentinel && (
                      <div className="relative top-[200px] text-center">
                        <p className="font-mulish text-[22px]">
                          No Clips to Display.
                        </p>
                      </div>
                    )}
                  {!filtersApplied && (
                    <div className="relative top-[200px] text-center">
                      <p className="font-mulish text-[22px]">
                        Please Apply Filters to View Clips.
                      </p>
                      <p className="font-mulish text-[18px]">
                        To view clips for all sites, leave the Site and Camera
                        filters empty.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        {!pageLoading &&
          activeClipsTab === "ailink" &&
          !(
            userInfo.permission.smtp &&
            !userInfo.permission.ailink &&
            !userInfo.permission.sentinel
          ) && (
            <div>
              <div
                className={
                  userPerissionNumber > 1
                    ? `absolute h-[152px] left-[0px] right-0`
                    : `absolute h-[92px] left-[0px] right-0`
                }
              >
                <div>
                  <div
                    className={
                      !navBarCollapsed
                        ? "font-mulish absolute left-[160px] top-[15px]"
                        : "font-mulish absolute left-[85px] top-[15px]"
                    }
                  >
                    <AILinkFilters
                      siteOptions={siteOptions}
                      loadingSites={loadingSites}
                      siteDropDownValue={siteDropDownValue}
                      setSiteDropDownValue={setSiteDropDownValue}
                      setCameraDropDownValue={setCameraDropDownValue}
                      setUserFilters={setUserFilters}
                      setCameraOptions={setCameraOptions}
                      setLoadingCameras={setLoadingCameras}
                      cameraDropDownValue={cameraDropDownValue}
                      cameraOptions={cameraOptions}
                      loadingCameras={loadingCameras}
                      userFilters={userFilters}
                      setClipsData={setClipsData}
                      setPageLoading={setPageLoading}
                      setSelectedRow={setSelectedRow}
                      setPrecisionRecallData={setPrecisionRecallData}
                      setVideoURL={setVideoURL}
                      setVideoClipLoading={setVideoClipLoading}
                      setClipsIndexOrder={setClipsIndexOrder}
                      setVerifiedClicked={setVerifiedClicked}
                      setUnverifiedClicked={setUnverifiedClicked}
                      selectedRow={selectedRow}
                      setNoDataToDisplay={setNoDataToDisplay}
                      setSiteOptions={setSiteOptions}
                      setLoadingSites={setLoadingSites}
                      setFetchingFilteredData={setFetchingFilteredData}
                      setPage={setPage}
                      showUserDropDown={showUserDropDown}
                      userDropDownValue={userDropDownValue}
                      userOptions={aiLinkUsers}
                      setUserDropDownValue={setUserDropDownValue}
                      groupID={groupID}
                      setGroupID={setGroupID}
                      setAiLinkClipsTotal={setAiLinkClipsTotal}
                      setLoadingAdditionalData={setLoadingAdditionalData}
                      navBarCollapsed={navBarCollapsed}
                      userInfo={userInfo}
                      setFiltersApplied={setFiltersApplied}
                      timeFiltersDisabledAILink={timeFiltersDisabledAILink}
                      setTimeFiltersDisabledAILink={
                        setTimeFiltersDisabledAILink
                      }
                      navigate={navigate}
                      setSearchParams={setSearchParams}
                    />
                  </div>
                </div>
              </div>
              <div>
                <div>
                  {!noDataToDisplay && (
                    <div>
                      <AILinkTab
                        showMoreDialogOpen={showMoreDialogOpen}
                        setShowMoreDialogOpen={setShowMoreDialogOpen}
                        selectedRow={selectedRow}
                        videoURL={videoURL}
                        clipsData={clipsData}
                        page={page}
                        setPage={setPage}
                        precisionRecallData={precisionRecallData}
                        videoClipLoading={videoClipLoading}
                        setVideoClipLoading={setVideoClipLoading}
                        setVideoURL={setVideoURL}
                        setSelectedRow={setSelectedRow}
                        setClipsData={setClipsData}
                        scrollToTop={scrollToTop}
                        verifiedClicked={verifiedClicked}
                        unverifiedClicked={unverifiedClicked}
                        setVerifiedClicked={setVerifiedClicked}
                        setUnverifiedClicked={setUnverifiedClicked}
                        setPageLoading={setPageLoading}
                        clipsIndexOrder={clipsIndexOrder}
                        setClipsIndexOrder={setClipsIndexOrder}
                        fetchingFilteredData={fetchingFilteredData}
                        userFilters={userFilters}
                        loadingAdditionalData={loadingAdditionalData}
                        navBarCollapsed={navBarCollapsed}
                        userInfo={userInfo}
                        navigate={navigate}
                      />
                    </div>
                  )}
                  {noDataToDisplay && filtersApplied && !fetchingFilteredData && (
                    <div className="relative top-[200px] text-center">
                      <p className="font-mulish text-[22px]">
                        No Clips to Display.
                      </p>
                    </div>
                  )}
                  {!filtersApplied && (
                    <div className="relative top-[200px] text-center">
                      <p className="font-mulish text-[22px]">
                        Please Apply Filters to View Clips.
                      </p>
                      <p className="font-mulish text-[18px]">
                        To view clips for all sites, leave the Site and Camera
                        filters empty.
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        {!pageLoadingSMTP && activeClipsTab === "smtp" && (
          <div>
            <div
              className={
                userPerissionNumber > 1
                  ? `absolute h-[152px] left-[0px] right-0`
                  : `absolute h-[92px] left-[0px] right-0`
              }
            >
              <div>
                <div
                  className={
                    !navBarCollapsed
                      ? "font-mulish absolute left-[160px] top-[15px]"
                      : "font-mulish absolute left-[85px] top-[15px]"
                  }
                >
                  <SMTPTabFilters
                    showUserDropDown={showUserDropDown}
                    navBarCollapsed={navBarCollapsed}
                    userOptions={parentAccounts}
                    setSearchParams={setSearchParams}
                  />
                </div>
              </div>
            </div>
            <div>
              <div>
                {!noDataToDisplaySMTP && (
                  <div>
                    <SMTPTab navBarCollapsed={navBarCollapsed} />
                  </div>
                )}
                {noDataToDisplaySMTP &&
                  filtersAppliedSMTP &&
                  !fetchingFilteredDataSMTP && (
                    <div className="relative top-[200px] text-center">
                      <p className="font-mulish text-[22px]">
                        No Clips to Display.
                      </p>
                    </div>
                  )}
                {!filtersAppliedSMTP && (
                  <div className="relative top-[200px] text-center">
                    <p className="font-mulish text-[22px]">
                      Please Apply Filters to View Clips.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {activeClipsTab === "frontel" && (
          <div>
            <div
              className={
                userPerissionNumber > 1
                  ? `absolute h-[152px] left-[0px] right-0`
                  : `absolute h-[92px] left-[0px] right-0`
              }
            >
              <div>
                <div
                  className={
                    !navBarCollapsed
                      ? "font-mulish absolute left-[160px] top-[15px]"
                      : "font-mulish absolute left-[85px] top-[15px]"
                  }
                >
                  <FrontelTabFilters
                    showUserDropDown={true}
                    navBarCollapsed={navBarCollapsed}
                    setSearchParams={setSearchParams}
                  />
                </div>
              </div>
            </div>
            <div>
              <div>
                {!noDataToDisplayFrontel && (
                  <div>
                    <FrontelTab navBarCollapsed={navBarCollapsed} />
                  </div>
                )}
                {noDataToDisplayFrontel &&
                  filtersAppliedFrontel &&
                  !fetchingFilteredDataFrontel && (
                    <div className="relative top-[200px] text-center">
                      <p className="font-mulish text-[22px]">
                        No Clips to Display.
                      </p>
                    </div>
                  )}
                {!filtersAppliedFrontel && (
                  <div className="relative top-[200px] text-center">
                    <p className="font-mulish text-[22px]">
                      Please Apply Filters to View Clips.
                    </p>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
      </>
      )}
      </div>
      <Snackbar
        open={urlClipNotFoundOpen}
        autoHideDuration={12000}
        onClose={handleUrlClipNotFoundClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <MuiAlert
          onClose={handleUrlClipNotFoundClose}
          severity="warning"
          sx={{ width: "100%", fontFamily: "Mulish" }}
        >
          Requested clip from URL was not found in current results.
        </MuiAlert>
      </Snackbar>
      <div className="justify-start">
        <NavBar
          navBarCollapsed={navBarCollapsed}
          setNavBarCollapsed={setNavBarCollapsed}
          props={{}}
        />
      </div>
    </div>
  );
};
